module.exports = __webpack_public_path__ + "img/ic_upload.6d31094f.svg";